export const CA_EVENT_TYPES = {
    PAGE_VIEW: "page_view",
    PHONE_NUMBER_DISPLAY: "phone_number_display",
    CONTACT_FORM_SUBMIT: "contact_form_submit",
    INTERMEDIARY_PROFILE_OPEN: "intermediary_profile_open",
    INTERMEDIARY_WEBSITE_OPEN: "intermediary_website_open",
    RECOMMENDED_CARD_VIEW: "classified_recommended_card_view",
    RECOMMENDED_CARD_VIEW_CONFIRMATION: "classified_recommended_card_view_confirmation",
};
